module.exports = __webpack_public_path__ + "static/media/twitter.551c8cab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter.svg
// module id = 1105
// module chunks = 0